import React from "react";
import { Modal, Button } from "antd";
import { t } from "i18next";

const CommonModal = ({
  title,
  visible,
  onCancel,
  onConfirm,
  confirmButtonText,
  confirmButtonType = "primary",
  confirmButtonDanger = false,
  children,
  width,
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      width={width}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="confirm"
          type={confirmButtonType}
          danger={confirmButtonDanger}
          onClick={onConfirm}
        >
          {confirmButtonText}
        </Button>,
      ]}
    >
      {children}
    </Modal>
  );
};

export default CommonModal;
